"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSnooze = function SvgIconSnooze(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "snooze icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Snooze Icon'), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "nonzero",
    d: "M29 19.6l-5.6 6.8H29V30H19v-3.6l5.6-6.8H19V16h10v3.6zM37 32V21c0-6.146-4.27-11.282-10-12.638V7a3.001 3.001 0 00-6 0v1.362C15.27 9.718 11 14.854 11 21v11l-4 4v2h34v-2l-4-4zM24 44a4 4 0 004-4h-8c0 2.208 1.792 4 4 4z"
  }));
};

var _default = SvgIconSnooze;
exports.default = _default;